// REVIEW: convert to domain object

export interface MosaicRoi {
  id: string;
  label: string;
  score: number;
  x0: number;
  x1: number;
  y0: number;
  y1: number;
  creatorEntity: string;
  creatorId: string;
  assetId: string;
  sampleId: string;
  analysisId: string;
  findingId: string;
  findingVersionId: string;
  findingVersion: number;
  stepId: string;
  pipelineId: string;
  /**
   * Content address of the row's crop - `SHA256({assetId, x0, x1, y0, y1})`.
   *
   * Names a crop rather than describing one, so it cannot be turned back into a
   * region to cut. Kept because the browser and the reports table read it, and
   * because it is what the legacy S3 proxy looks up.
   */
  cropFile: string;
}

/** Full primary key of an ROI row: partitioned by label, sorted by id. */
export type MosaicRoiKey = Pick<MosaicRoi, "id" | "label">;

export const notContainedIn = (array: MosaicRoi[]) => (r1: MosaicRoi) =>
  !array.some((r2) => r2.id === r1.id && r2.label === r1.label);

export function checkIfROI(item: MosaicRoi): boolean {
  const { x0, x1, y0, y1 } = getCoordAsNum(item);

  return x0 !== x1 && y0 !== y1;
}

export function isOneDimensionalRoi(item: MosaicRoi): boolean {
  const { x0, x1, y0, y1 } = getCoordAsNum(item);
  const widthIsZero = x0 === x1;
  const heightIsZero = y0 === y1;

  return widthIsZero !== heightIsZero;
}

export function getRoiPoiCenter(item: MosaicRoi): { x: number; y: number } {
  const { x0, x1, y0, y1 } = getCoordAsNum(item);

  return {
    x: x0 === x1 ? x0 : (x0 + x1) / 2,
    y: y0 === y1 ? y0 : (y0 + y1) / 2,
  };
}

export function checkIfOutOfBounds(item: MosaicRoi) {
  const { x0, x1, y0, y1 } = getCoordAsNum(item);

  const isWithinBounds =
    isNormarilzed(x0) &&
    isNormarilzed(x1) &&
    isNormarilzed(y0) &&
    isNormarilzed(y1);

  return !isWithinBounds;
}

export function isNormarilzed(n: number) {
  return n >= 0 && n <= 1;
}

export function getCoordAsNum(item: MosaicRoi) {
  const x0 = Number(item.x0);
  const x1 = Number(item.x1);
  const y0 = Number(item.y0);
  const y1 = Number(item.y1);

  return { x0, x1, y0, y1 };
}
